const TypeProducts = {
  guarnicion: "Guarnición",
  bebida: "Bebida",
};

export default TypeProducts;
